import React, { useState } from "react";
import ChildRow from "./ChildRow";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import style from "../Application.module.scss";
import DropDown from "../../../components/DropDown/DropDown";
import AppStatusDot from "./AppStatusDot/AppStatusDot";
import Checkbox from "../../../components/Checkbox/Index";
import { dateFormatter } from "../../../../components/helper/helper";
import AssignProcessor from "./AssignProcessor/AssignProcessor";
import ChangeOwner from "./ChangeOwner/ChangeOwner";
import CopyApplication from "./CopyApplication/Index";
import EditEmail from "./EditEmail/EditEmail";
import EditMobile from "./EditMobile/EditMobile";
import ConfirmationModal from "./ConfirmationModal/ConfirmationModal";
import { cancelMultipleApp, deleteBulkApps } from "../../../../api";
import config from "../../../../config";
import toast from "react-hot-toast";
import useApplicationStore from "../../../stores/application";
import useCommonStore from "../../../stores/common";
import useUserStore from "../../../stores/user";
import AssignMSP from "./AssignMSP";
import EditZoho from "./EditZoho/EditZoho";

const MAIN_URL = config.paymentcloud.MAIN_URL;

function ApplicationRow({ app, fetchList }) {
  const [childAppOpen, setChildAppOpen] = useState(false);
  const [openAssignProcessor, setOpenAssignProcessor] = useState(false);
  const [showChangeOwner, setShowChangeOwner] = useState(false);
  const [confirmCopyApplication, setConfirmCopyApplication] = useState(false);
  const [openEditEmail, setOpenEditEmail] = useState(false);
  const [openEditMobile, setOpenEditMobile] = useState(false);
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState(false);
  const [confirmAppDelete, setConfirmAppDelete] = useState(false);
  const [assignMspModal, setAssignMspModal] = useState(false);
  const [editZohoModal, setEditZohoModal] = useState(false);
  const [zohoIdType, setZohoIdType] = useState("zoho_id");

  const loggedInUser = useUserStore((state) => state.user);

  const showDetails = useCommonStore((state) => state.showDetails);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const activeApp = useApplicationStore((state) => state.activeApp);
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);
  const selectedApps = useApplicationStore((state) => state.selectedApps);

  const updateSelectedApps = (event) => {
    const appId = +event.target.value;
    useApplicationStore.setState((prevState) => ({
      selectedApps: event.target.checked
        ? [...prevState.selectedApps, appId]
        : prevState.selectedApps.filter((id) => id !== appId),
    }));
  };

  const updateChildAppSelection = (event) => {
    const isChecked = event.target.checked;
    let ids = [+app.id];
    app.child.forEach(child => {
      ids.push(+child.id);
    });

    useApplicationStore.setState((prevState) => ({
      selectedApps: isChecked
        ? [...new Set([...prevState.selectedApps, ...ids])]
        : prevState.selectedApps.filter((id) => !ids.includes(id)),
    }));
  };

  const editApplication = () => {
    let link = "";
    if (app?.user?.channel == "sales_channel") {
      link = `${MAIN_URL}${app.user.agent_url}/${app.editslug}`;
    } else {
      link = `${MAIN_URL}${app.organization.whitelabel_slug}/${app.user.agent_url}/${app.editslug}`;
    }
    window.open(link);
  };

  const handleEditZoho = (type) => {
    setZohoIdType(type);
    setEditZohoModal(true);
  };

  const drop_down_options = [
    {
      text: "Assign Processor",
      type: "normal",
      onClick: () => {
        setOpenAssignProcessor(true);
      },
    },
    {
      text: "Assign MSP",
      type: "normal",
      onClick: () => {
        setAssignMspModal(true);
      },
    },
    {
      text: "Change owner",
      type: "normal",
      onClick: () => {
        setShowChangeOwner(true);
      },
    },
    {
      text: "Duplicate Application",
      type: "normal",
      onClick: () => {
        setConfirmCopyApplication(true);
      },
    },
    {
      text: "Edit Zoho ID",
      type: "normal",
      onClick: () => {
        handleEditZoho("zoho_id");
      },
    },
    {
      text: "Edit Submission ID", 
      type: "normal",
      onClick: () => {
        handleEditZoho("submission_id");
      },
    },
    {
      text: "Edit Application",
      type: "normal",
      onClick: () => {
        editApplication();
      },
    },
    {
      text: "Edit OTP Email",
      type: "normal",
      onClick: () => {
        setOpenEditEmail(true);
      },
    },
    {
      text: "Edit OTP Mobile",
      type: "normal",
      onClick: () => {
        setOpenEditMobile(true);
      },
    },
    {
      text: "Cancel",
      type: "danger",
      onClick: () => {
        setOpenCancelConfirmation(true);
      },
    },
    {
      text: "Delete",
      type: "danger",
      onClick: () => {
        setConfirmAppDelete(true);
      },
    },
  ];

  const cancelApplication = async () => {
    const toastID = toast.loading('Cancelling apps...');
    const response = await cancelMultipleApp({ ids: [app?.id] });
    if (response.status) {
      toast.success('Apps cancelled successfully', { id: toastID });
      setOpenCancelConfirmation(false);
      fetchList();
    } else {
      toast.error('Something went wrong', { id: toastID });
    }
  }

  const deleteApplication = async () => {
    const toastID = toast.loading('Deleting apps...');
    const response = await deleteBulkApps({ bulkDeleteIds: [app?.id] });
    if (response.status) {
      toast.success('Apps deleted successfully', { id: toastID });
      fetchList();
      setConfirmAppDelete(false);
    } else {
      toast.error('Something went wrong', { id: toastID });
    }
  }

  return (
    <>
      <tr
        className={`${activeApp?.id == app.id ? style.active_app : ""}`}
      // onClick={() => {
      //   setActiveApp(app);
      //   setShowDetails(true);
      // }}
      >
        <td>
          <Checkbox
            value={app.id}
            onChange={(event) => {
              if (app.child.length > 0) {
                updateChildAppSelection(event)
              } else {
                updateSelectedApps(event)
              }
            }}
            checked={
              app.child.length > 0
                ? app.child.every((child) => selectedApps.includes(child.id)) && selectedApps.includes(app.id)
                : selectedApps.includes(app.id)
            }
          />
          {app?.child?.length > 0 && (
            <ButtonIcon
              onClick={() => setChildAppOpen(!childAppOpen)}
              bgColor={"transparent"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className={`${style.caret_icon} ${childAppOpen ? style.rotate_90 : ""}`}
              >
                <path
                  d="M11.3535 8.35391L6.35354 13.3539C6.30708 13.4004 6.25193 13.4372 6.19124 13.4624C6.13054 13.4875 6.06549 13.5004 5.99979 13.5004C5.93409 13.5004 5.86904 13.4875 5.80834 13.4624C5.74764 13.4372 5.69249 13.4004 5.64604 13.3539C5.59958 13.3075 5.56273 13.2523 5.53759 13.1916C5.51245 13.1309 5.49951 13.0659 5.49951 13.0002C5.49951 12.9345 5.51245 12.8694 5.53759 12.8087C5.56273 12.748 5.59958 12.6929 5.64604 12.6464L10.2929 8.00016L5.64604 3.35391C5.55222 3.26009 5.49951 3.13284 5.49951 3.00016C5.49951 2.86747 5.55222 2.74023 5.64604 2.64641C5.73986 2.55259 5.86711 2.49988 5.99979 2.49988C6.13247 2.49988 6.25972 2.55259 6.35354 2.64641L11.3535 7.64641C11.4 7.69284 11.4369 7.74799 11.4621 7.80869C11.4872 7.86938 11.5002 7.93445 11.5002 8.00016C11.5002 8.06586 11.4872 8.13093 11.4621 8.19163C11.4369 8.25233 11.4 8.30747 11.3535 8.35391Z"
                  fill="#3A383F"
                />
              </svg>
            </ButtonIcon>
          )}
        </td>
        <td
          onClick={() => {
            setActiveApp(app);
            setShowDetails(true);
          }}
        >{app.field_dba}
        </td>
        <td
          onClick={() => {
            setActiveApp(app);
            setShowDetails(true);
          }}
        >
          <div className="status">
            <AppStatusDot
              progression_id={app?.progression_id}
              hasChild={app.child.length > 0}
            />
            {app.child.length > 0 &&
              app.child.map((app, index) => (
                <AppStatusDot
                  key={index}
                  progression_id={app?.progression_id}
                  hasChild={true}
                />
              ))}
          </div>
        </td>
        {!showDetails && <td
          onClick={() => {
            setActiveApp(app);
            setShowDetails(true);
          }}
        >{app.id}</td>}
        <td
          onClick={() => {
            setActiveApp(app);
            setShowDetails(true);
          }}
        >{app?.organization?.name || "-"}</td>
        {!showDetails && (
          <>
            <td>
              ${" "}
              {app?.bankinfo?.maxsales
                ? parseInt(app?.bankinfo?.maxsales)
                  .toFixed(2)
                  ?.toLocaleString("en-US")
                : "0.00"}
            </td>
            <td>{app?.created_at ? dateFormatter(app?.created_at) : ""}</td>
          </>
        )}
        {/* TODO: Add alerts column will do later */}
        {/* <td>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="7" fill="#E03B24" fillOpacity="0.2" />
            <circle cx="8" cy="8" r="3" fill="#E03B24" />
          </svg>
        </td> */}
        {!showDetails && (
          <td>
            <DropDown options={drop_down_options}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M10.5 5.625C10.5 5.32833 10.588 5.03832 10.7528 4.79165C10.9176 4.54497 11.1519 4.35271 11.426 4.23918C11.7001 4.12565 12.0017 4.09594 12.2926 4.15382C12.5836 4.2117 12.8509 4.35456 13.0607 4.56434C13.2704 4.77412 13.4133 5.04139 13.4712 5.33237C13.5291 5.62334 13.4994 5.92494 13.3858 6.19903C13.2723 6.47311 13.08 6.70738 12.8334 6.87221C12.5867 7.03703 12.2967 7.125 12 7.125C11.6022 7.125 11.2206 6.96697 10.9393 6.68566C10.658 6.40436 10.5 6.02283 10.5 5.625ZM12 10.5C11.7033 10.5 11.4133 10.588 11.1666 10.7528C10.92 10.9176 10.7277 11.1519 10.6142 11.426C10.5006 11.7001 10.4709 12.0017 10.5288 12.2926C10.5867 12.5836 10.7296 12.8509 10.9393 13.0607C11.1491 13.2704 11.4164 13.4133 11.7074 13.4712C11.9983 13.5291 12.2999 13.4994 12.574 13.3858C12.8481 13.2723 13.0824 13.08 13.2472 12.8334C13.412 12.5867 13.5 12.2967 13.5 12C13.5 11.6022 13.342 11.2206 13.0607 10.9393C12.7794 10.658 12.3978 10.5 12 10.5ZM12 16.875C11.7033 16.875 11.4133 16.963 11.1666 17.1278C10.92 17.2926 10.7277 17.5269 10.6142 17.801C10.5006 18.0751 10.4709 18.3767 10.5288 18.6676C10.5867 18.9586 10.7296 19.2259 10.9393 19.4357C11.1491 19.6454 11.4164 19.7883 11.7074 19.8462C11.9983 19.9041 12.2999 19.8744 12.574 19.7608C12.8481 19.6473 13.0824 19.455 13.2472 19.2084C13.412 18.9617 13.5 18.6717 13.5 18.375C13.5 17.9772 13.342 17.5956 13.0607 17.3143C12.7794 17.033 12.3978 16.875 12 16.875Z"
                  fill="#3A383F"
                />
              </svg>
            </DropDown>
          </td>
        )}
      </tr>
      {childAppOpen && (
        <ChildRow
          children={app.child}
          organization={app?.organization?.name}
          app={app}
        />
      )}

      {/* Actions */}
      {/* Assign processor */}
      {openAssignProcessor && (
        <AssignProcessor
          open={openAssignProcessor}
          onClose={() => setOpenAssignProcessor(false)}
          app={app}
        />
      )}
      {/* Change owner */}
      {showChangeOwner && (
        <ChangeOwner
          open={showChangeOwner}
          onClose={() => setShowChangeOwner(false)}
          app={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Duplicate confirmation */}
      {confirmCopyApplication && (
        <CopyApplication
          isOpen={confirmCopyApplication}
          onClose={() => setConfirmCopyApplication(false)}
          appData={app}
          loggedInUser={loggedInUser}
          fetchApplication={fetchList}
        />
      )}
      {/* Edit email */}
      {openEditEmail && (
        <EditEmail
          open={openEditEmail}
          onClose={() => setOpenEditEmail(false)}
          appData={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Edit mobile */}
      {openEditMobile && (
        <EditMobile
          open={openEditMobile}
          onClose={() => setOpenEditMobile(false)}
          appData={app}
          fetchApplication={fetchList}
        />
      )}
      {/* Cancel confirmation */}
      {openCancelConfirmation && (
        <ConfirmationModal
          open={openCancelConfirmation}
          onClose={() => setOpenCancelConfirmation(false)}
          message={"Are you sure you want to cancel this app? You can't undo this action."}
          onConfirmClick={() => cancelApplication()}
        />
      )}
      {/* delete confirmation */}
      {confirmAppDelete && (
        <ConfirmationModal
          open={confirmAppDelete}
          onClose={() => setConfirmAppDelete(false)}
          message={"Are you sure you want to Delete this app? You can't undo this action."}
          onConfirmClick={() => deleteApplication()}
        />
      )}
      {/* Assign MSP */}
      {assignMspModal && (
        <AssignMSP
          open={assignMspModal}
          onClose={() => setAssignMspModal(false)}
          appData={app}
        />
      )}
      {/* Edit Zoho ID */}
      {editZohoModal && (
        <EditZoho
          open={editZohoModal}
          onClose={() => setEditZohoModal(false)}
          appData={app}
          getAppData={fetchList}
          zohoIdType={zohoIdType}
        />
      )}

    </>
  );
}

export default ApplicationRow;
